import React, { Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Typo } from 'tmt-ui-kit';

import { commaize } from '~/utils/helpers';

const SmallText = styled(Typo.Paragraph)`
  font-size: 13px !important;
  margin: 0;
`;

const StrikeText = styled(SmallText)`
  text-decoration: line-through;
  margin: 0;
`;

const SpanBig = styled.span`
  position: relative;
  top: -2px;
  font-size: 16px !important;
  font-weight: 500 !important;
  font-family: ${props => props.theme.font};
  color: ${props => props.theme.black} !important;
`;

const Spanner = styled.span`
  font-size: 16px;
  font-weight: 300;
  margin-left: 4px !important;
`;

const SpanPrice = styled.span`
  color: ${props => (props.highlightPrice ? props.theme.orange : props.theme.black)} !important;
`;

const PriceBlock = props => {
  const { price, currency, ticketPrice, displayPrice, highlightPrice, specialUnit } = props;
  return (
    <Fragment>
      {price && !ticketPrice && <StrikeText>{currency} {commaize(price, currency)}</StrikeText>}
      {ticketPrice && !highlightPrice && <SmallText>Starting at</SmallText>}
      {ticketPrice ? (
        <SpanBig>{highlightPrice && 'Starting at '}<SpanPrice highlightPrice={highlightPrice}>{currency} {commaize(ticketPrice, currency)}</SpanPrice></SpanBig>)
        : (displayPrice && (
          <SpanBig>
            <SpanPrice highlightPrice={highlightPrice}>{currency} {commaize(displayPrice, currency)}</SpanPrice>
            <Spanner> / {specialUnit || 'Person'}</Spanner>
          </SpanBig>)
        )
      }
    </Fragment>
  );
};

PriceBlock.propTypes = {
  price: PropTypes.number,
  currency: PropTypes.string,
  ticketPrice: PropTypes.number,
  displayPrice: PropTypes.number,
  highlightPrice: PropTypes.bool,
  specialUnit: PropTypes.string,
};

export default PriceBlock;
